module.exports = __webpack_public_path__ + "img/arrow-right-light.9c18fe19.svg";